import React from "react";

const ComplimentaryShipping=()=>{

    return (
      <div className='w-full h-full flex flex-col gap-6 p-6 md:p-10 text-gray-800 leading-relaxed'>
        <h1 className='text-2xl md:text-3xl font-semibold underline text-center'>
          Complimentary Shipping and exchange
        </h1>
        <ul className='ml-10 list-disc flex flex-col gap-2'>
          <li>
            {' '}
            Enjoy free, secure shipping on every order placed through Mukunda
            Jewellers.
          </li>
          <li>
            {' '}
            If you wish to exchange a product, our customer-friendly exchange
            process makes it simple and convenient.
          </li>
          <li>
            Customers can avail 100% exchange value on gold, diamond, and silver
            jewellery within 7 days from the date of delivery or purchase.
          </li>
          <li>
            {' '}
            For exchange made after 7 days, a 70% exchange value will be
            provided.
          </li>
          <li>
            Please note that all exchange services can only be availed by
            visiting any Mukunda Jewellers store.
          </li>
        </ul>
        
      </div>
    );

}

export default ComplimentaryShipping